import React, { Component } from "react";
import { Button, Form, Icon, Modal, Table } from "semantic-ui-react";
import PropTypes from "prop-types";

const inlineStyle = {
    modal: {
        marginTop: "0px !important",
        marginLeft: "auto",
        marginRight: "auto"
    }
};

class StockByWarehouse extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            selectedWarehouse: null,
            target: 0
        };

    }

    render() {

        const { warehouses, stockByWarehouse, targets, suggestedTargets } = this.props;

        return (
            <div>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Warehouse</Table.HeaderCell>
                            <Table.HeaderCell>Stock</Table.HeaderCell>
                            <Table.HeaderCell>Target</Table.HeaderCell>
                            <Table.HeaderCell>Suggested Target</Table.HeaderCell>
                            <Table.HeaderCell>Set Target</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            Object.keys(stockByWarehouse)
                                .map((key) => {

                                    return <Table.Row
                                        key={key}>
                                        <Table.Cell>{warehouses ? warehouses.reduce((a, b) => {
                                            return Number.parseInt(b.id, 10) === Number.parseInt(key, 10) ? b.name : a;
                                        }, "Warehouse not found") : "Warehouse not found"}</Table.Cell>

                                        <Table.Cell>{stockByWarehouse[key]}</Table.Cell>
                                        <Table.Cell
                                            style={targets[key] > stockByWarehouse[key] ? { backgroundColor: "rgba( 255, 153, 0,0.5)" } : { backgroundColor: "rgba(199,234,70,0.5)" }}>{targets[key]}</Table.Cell>
                                        <Table.Cell
                                            style={suggestedTargets[key] > stockByWarehouse[key] ? { backgroundColor: "rgba( 255, 153, 0,0.5)" } : { backgroundColor: "rgba(199,234,70,0.5)" }}>{suggestedTargets[key]}</Table.Cell>

                                        <Table.Cell>
                                            <Button
                                                onClick={() => {
                                                    this.setState({
                                                        modalOpen: true,
                                                        selectedWarehouse: key,
                                                        target: targets[key]
                                                    });
                                                }}
                                            >Set Target</Button>
                                        </Table.Cell>
                                    </Table.Row>;
                                })
                        }

                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell/>
                            <Table.HeaderCell>{Object.values(stockByWarehouse)
                                .reduce((a, b) => {
                                    return a + b;
                                }, 0)}</Table.HeaderCell>
                            <Table.HeaderCell>{Object.values(targets)
                                .reduce((a, b) => {
                                    return a + b;
                                }, 0)}</Table.HeaderCell>
                            <Table.HeaderCell>{Object.values(suggestedTargets)
                                .reduce((a, b) => {
                                    return a + b;
                                }, 0)}</Table.HeaderCell>
                            <Table.HeaderCell/>
                        </Table.Row>

                    </Table.Footer>
                </Table>
                <Modal
                    style={inlineStyle.modal}
                    open={this.state.modalOpen}
                >
                    <Modal.Header>Set Target</Modal.Header>
                    <Form
                        onSubmit={(e) => {
                            this.props.onTargetChange(this.state.selectedWarehouse, this.state.target);
                            this.setState({
                                target: 0,
                                selectedWarehouse: null,
                                modalOpen: false
                            })
                        }}>
                        <Modal.Content
                            image>
                            <Modal.Description>
                                <Form.Input
                                    value={this.state.target}
                                    onChange={(e, {value})=>{this.setState({target: value})}}
                                    name='newTarget'
                                    type='number'/>
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                basic
                                color='red'
                                inverted>
                                <Icon
                                    name='remove'/> No
                            </Button>
                            <Button
                                color='green'
                                inverted>
                                <Icon
                                    name='checkmark'/> Yes
                            </Button>
                        </Modal.Actions>
                    </Form>
                </Modal>

            </div>
        );
    }
}


StockByWarehouse.propTypes = {
    warehouses: PropTypes.array.isRequired,
    stockByWarehouse: PropTypes.object.isRequired,
    targets: PropTypes.object.isRequired,
    suggestedTargets: PropTypes.object.isRequired,
    onTargetChange: PropTypes.func.isRequired
};


export default StockByWarehouse;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/components/DetailTab/components/StockByWarehouse/index.js